import React, { useMemo } from 'react';

//import { useEffect } from 'react';
import { forceReloadProjectPackages, useProjectPackages } from '@hooks/API/Project/UseProjectPackages';

import { Loading } from '@components/Gui/Loading';
//import Axios from 'axios';

import NwIcon from '@components/Gui/NwIcon';

import PackageCard from '@containers/Booking/Packages/PackagesContent/PackageCard';

//useState
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ProjectPackagesOverview = ({ projectId, onMoveToEvent }) => {
    const { isLoading, error, data: projectPackages } = useProjectPackages(projectId);

    const reloadPackages = () => {
        forceReloadProjectPackages(projectId);
        //setFetchingPackages(true)
        //fetchPackages()
    };

    const displayPackages = useMemo(() => {
        if (isLoading) {
            return [];
        }
        if (!projectPackages) {
            return [];
        }
        const sortedpackages = projectPackages.sort(
            (p1, p2) => new Date(p2.ExpirationDate) - new Date(p1.ExpirationDate)
        );
        return sortedpackages;
    }, [projectPackages, isLoading]);

    return (
        <div className="internal-card">
            <div className="header">
                <div className="title-container">
                    <NwIcon className="icon" icon={byPrefixAndName.fasl['book-arrow-right']} />
                    <div className="title">Packages</div>
                </div>
            </div>
            <div className="content">
                {isLoading ? (
                    <Loading textBlack />
                ) : (
                    displayPackages.map((pack) => {
                        return (
                            <PackageCard
                                page="project"
                                small
                                key={pack.ID}
                                pack={pack}
                                multipleSelection={false}
                                onSelect={() => {}}
                                onCloseDrawer={() => reloadPackages()}
                            />
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default ProjectPackagesOverview;
